import { render, staticRenderFns } from "./ModalRemove.vue?vue&type=template&id=79a94285&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"
import style0 from "./ModalRemove.vue?vue&type=style&index=0&id=79a94285&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a94285",
  null
  
)

export default component.exports